export default function LargeButtons ({ buttons }) {
  return (
    <div className='donate-button-container'>
      {buttons.map(button => (
        <a
          href={button.button_link.url}
          target={button.button_link.target}
          className={`link donate-link ${
            button.button_style === 'dark' ? 'donate-link-dark' : ''
          }`}
        >
          {button.button_text}
        </a>
      ))}
    </div>
  )
}
